const zh = {
  nav_dashboard: '仪表板', nav_inventory: '库存', nav_my_stock: '我的库存',
  nav_containers: '集装箱', nav_requests: '请求', nav_invoices: '发票',
  nav_payments: '付款', nav_settings: '设置', nav_sign_out: '退出登录',
  nav_customers: '客户', nav_employees: '员工', nav_tasks: '任务',
  nav_scan: '扫描', nav_pricing: '定价', nav_price_quotes: '报价',
  nav_selection_orders: '选择订单',
  btn_save: '保存', btn_cancel: '取消', btn_delete: '删除', btn_edit: '编辑',
  btn_add: '添加', btn_submit: '提交', btn_approve: '批准', btn_reject: '拒绝',
  btn_search: '搜索', btn_confirm: '确认', btn_sign_in: '登录',
  btn_save_changes: '保存更改',
  login_title: 'BIG STAR', login_subtitle: '汽车出口管理系统',
  login_username: '用户名', login_email: '邮箱', login_password: '密码',
  login_remember: '记住我', login_invalid: '凭据无效',
  detail_make: '制造商', detail_model: '型号', detail_year: '年份',
  detail_chassis: '车架号', detail_color: '颜色', detail_mileage: '里程',
  detail_grade: '等级', detail_condition: '状况', detail_status: '状态',
  detail_price: '价格', detail_fob: 'FOB价格',
  status_available: '可用', status_shipped: '已发货',
  status_delivered: '已交付', status_pending: '待处理',
  vehicles: '车辆', engines: '发动机', parts: '零件', dashboard: '仪表板',
  add: '添加', edit: '编辑', save: '保存', cancel: '取消', search: '搜索',
  noData: '暂无数据', dash_welcome: '欢迎，{name}',
  dash_total_fob: 'FOB总值',
  dash_late_night: '深夜好', dash_hello: '你好',
  dash_subtitle: '您的车队、零件和入库货运概览——实时更新。',
  dash_local_time: '当地时间', dash_status: '状态', dash_all_systems_live: '所有系统正常运行',
  dash_view_recommendations: '查看推荐', dash_my_stock: '我的库存', dash_in_transit: '运输中',
  dash_units: '台', dash_containers: '集装箱', dash_browse_more: '浏览更多',
  dash_track_shipments: '追踪货运', dash_browse_inventory_start: '浏览库存开始选购',
  dash_no_active_shipments: '暂无活跃货运', dash_next_eta: '下次到达', dash_days: '天',
  dash_etas_confirming: '到达日期确认中', dash_this_week: '本周',
  dash_arriving_soon: '即将到达', dash_logistics: '物流', dash_active_shipments: '活跃货运',
  dash_view_all: '查看全部', dash_shipment_empty: '当车辆装入集装箱后，您的下一批货运将显示在这里',
  dash_composition: '构成', dash_stock_breakdown: '库存明细', dash_no_units_yet: '暂无车辆',
  dash_browse_to_build: '浏览库存以建立您的车队',
  dash_for_you: '为您推荐', dash_picked_based: '根据您的库存推荐', dash_browse_all: '浏览全部',
  dash_picking_units: '我们正在为您挑选车辆。请稍后查看，或浏览全部库存',
  dash_view_details: '查看详情', dash_just_arrived: '新到', dash_similar: '与您相似',
  dash_today: '今天', dash_tomorrow: '明天',
};
export default zh;
